
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

/**
 * 웹파트 템플릿을 추가/편집/삭제를 통해 관리하는 화면
 */
@Component({
    name: 'template-list-item',
})
export default class TemplateListItem extends Vue {
    @Prop({ type: Object, required: true }) template!: webpartv3.WebpartTemplate

    get size(): string {
        const { cols, rows } = this.template
        return ` ${rows} x ${cols}`
    }
}
